import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'
import { doUpdateCurrentUserForOnboarding } from 'ducks/currentUser/operations'
import { doUpdateCompanyProfile } from '../../ducks/companyProfile'
import { V2_COMPLETION_PAGE, V2_PASSWORD_PAGE } from '../pages'

export function doSaveAndRedirect(fields) {
  return (dispatch, getState) => {
    const userFields = {
      name: fields.name,
      companyRole: fields.companyRole,
    }
    let hearAboutUs = null
    if (fields.companyHearAboutUsText !== '') {
      hearAboutUs = fields.companyHearAboutUsText
    } else {
      hearAboutUs = fields.companyHearAboutUsSelect
    }
    const companyFields = {
      hearAboutUs,
    }
    return dispatch(doUpdateCompanyProfile(companyFields)).then(() => {
      return dispatch(doUpdateCurrentUserForOnboarding(userFields)).then(() => {
        const state = getState()
        const currentUser = selectCurrentUser(state)
        if (currentUser.oauthAuthenticatable) {
          dispatch({
            type: V2_COMPLETION_PAGE,
          })
        } else {
          dispatch({
            type: V2_PASSWORD_PAGE,
          })
        }
      })
    })
  }
}
